module.exports = __webpack_public_path__ + "img/CameraZOOM-20220323150752026.5b9398d8.jpg";